import { Typography } from "components/parts/Typography/Typography";
import { useFormik } from "formik";
import { DisplayMonitor } from "pages/MonitorManagement/hook";
import React, { useEffect } from "react";
import { useState } from "react";
import { validationSchemaMonitor } from "utils/validation";
import {
  StyledDiv,
  StyledEditableInputText,
  StyledEditableNameplate,
  StyledEditIcon,
  StyledForm,
  StyledTypoDiv,
} from "./styled";

type EditableNameplateProps = {
  initValue: string;
  targetMonitor: DisplayMonitor;
  callBack: (targetId: string, inputValue: string) => Promise<void>;
};

export const EditablePlate: React.FC<EditableNameplateProps> = ({
  initValue,
  targetMonitor,
  callBack,
}) => {
  const [isEdit, setIsEdit] = useState<boolean>(false);

  useEffect(() => {
    formik.setFieldValue("memo", initValue);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const changeDisplayMode = () => {
    setIsEdit((prevState) => !prevState);
  };

  const onSubmit = async (values: { memo: string }) => {
    await callBack(targetMonitor.id, values.memo);
    setIsEdit(false);
  };

  const formik = useFormik({
    initialValues: {
      memo: initValue,
    },
    validationSchema: validationSchemaMonitor(),
    onSubmit: onSubmit,
  });

  const displayInquiryMode = () => {
    return (
      <>
        <StyledDiv>
          <StyledTypoDiv>
            <Typography textAlign="left" text={formik.values.memo} />
          </StyledTypoDiv>
          <StyledEditIcon
            size="20px"
            className="edit"
            type="button"
            onClick={changeDisplayMode}
          />
        </StyledDiv>
      </>
    );
  };

  const displayEditMode = () => {
    return (
      <>
        <StyledForm onSubmit={formik.handleSubmit} style={{ width: "100%" }}>
          <StyledDiv>
            <StyledEditableInputText
              {...formik.getFieldProps("memo")}
              height="2rem"
              autoFocus
              onBlur={() => {
                setIsEdit(false);
                formik.setFieldValue("memo", initValue);
              }}
            />
          </StyledDiv>
          {formik.touched.memo && formik.errors.memo && (
            <Typography text={formik.errors.memo} color="errorText" />
          )}
        </StyledForm>
      </>
    );
  };

  return (
    <StyledEditableNameplate>
      {isEdit ? displayEditMode() : displayInquiryMode()}
    </StyledEditableNameplate>
  );
};
